import { EducationType } from "@/types/data";

export const educationList: EducationType[] = [
    {
        since: "2022 - present",
        name: "Rajamangala University of Technology Isan",
        logo: "https://sci.rmuti.ac.th/main/wp-content/uploads/2022/02/RMUTI_KORAT.png",
        info: "Bachelor of Computer Engineering",
        gpax: "3.72"
    },
    {
        since: "2019 - 2022",
        name: "Ubon Ratchathani Technical College",
        logo: "https://rms.utc.ac.th/files/01013_1809190994117.png",
        info: "Vocational certificate of Technical Computer",
        gpax: "3.56"
    },
    {
        since: "2016 - 2019",
        name: "Narinukul School",
        logo: "https://narinukun.stumis.in/favicon.png",
        info: "Middle School",
        gpax: "2.96"
    },
    {
        since: "2008 - 2016",
        name: "Anuban Ubon Ratchathani School",
        logo: "https://lh5.googleusercontent.com/proxy/ZqCaJ38F50Zhx-9o3An57kA2yjUSpAgGbA8udZEAy2T8EBFwQT_pbjGG4z6S5l7NPl67Zw4GwwMwFpYaQ6Pcq5esk_McwgADar_9J_ylfgW8l1VBu22XQq1lKBviHA",
        info: "Primary School",
        gpax: "2.96"
    },
]